import { render, staticRenderFns } from "./PaymentConfirm.vue?vue&type=template&id=730fc058"
import script from "./PaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports